import React from 'react';
import { Card } from 'antd';
import { useParams } from 'react-router-dom';

const ProductsEdit: React.FC = () => {
  const { id } = useParams();

  return (
    <Card title="编辑商品">
      编辑商品页面 - ID: {id}
    </Card>
  );
};

export default ProductsEdit;
